module.exports = __webpack_public_path__ + "static/media/gift-returns-1.60a6fe91.png";